"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const React = require("react");
const common = require("@grandvisionhq/common");
const irisUi = require("@grandvisionhq/iris-ui");
const libUtilsReact = require("@grandvisionhq/lib-utils-react");
const libUtilsW3c = require("@grandvisionhq/lib-utils-w3c");
const state = require("@grandvisionhq/state");
const FeatureTogglesControlPanelTrigger = require("../components/FeatureTogglesControlPanelTrigger/FeatureTogglesControlPanel/components/FeatureTogglesControlPanelTrigger/FeatureTogglesControlPanelTrigger.js");
;/* empty css                                 */
function _interopNamespaceCompat(e) {
  if (e && typeof e === "object" && "default" in e) return e;
  const n = Object.create(null, { [Symbol.toStringTag]: { value: "Module" } });
  if (e) {
    for (const k in e) {
      n[k] = e[k];
    }
  }
  n.default = e;
  return Object.freeze(n);
}
const React__namespace = /* @__PURE__ */ _interopNamespaceCompat(React);
const FeatureTogglesControlPanel = () => {
  const { featureConfigs, isDebugModeFeatureTogglesEnabled, setFeatureToggles, ...featureToggles } = state.useFeatureToggles();
  const [featuresChanged, setFeaturesChanged] = libUtilsW3c.useLocalStorage("gv:featureTogglesDebugger", {});
  const [isFeatureToggleDebugModeActivated] = libUtilsW3c.useLocalStorage("gv:debug:featureToggles", false);
  const [isClearingCache, setIsClearingCache] = React__namespace.useState(false);
  const isClient = libUtilsReact.useIsClient();
  React__namespace.useEffect(() => {
    const newFeatures = {
      featureConfigs,
      ...featureToggles,
      isDebugModeFeatureTogglesEnabled,
      ...featuresChanged
    };
    setFeatureToggles(newFeatures);
  }, []);
  const drawerDirection = common.useDrawerDirection();
  const isRightDirection = drawerDirection === "right";
  const Title = /* @__PURE__ */ React__namespace.createElement(common.Drawer.Title, null, "Feature Toggles");
  const enabledFeatures = React__namespace.useMemo(
    () => Object.keys(featureToggles).filter((feature) => featureToggles[feature]),
    [featureToggles]
  );
  const handleCheckboxChange = (next) => {
    const added = next.filter((x) => !enabledFeatures.includes(x));
    const removed = enabledFeatures.filter((x) => !next.includes(x));
    const changed = added.length ? { [`${added[0]}`]: true } : removed.length ? { [`${removed[0]}`]: false } : null;
    if (changed) {
      const newFeatures = {
        featureConfigs,
        ...featureToggles,
        isDebugModeFeatureTogglesEnabled,
        ...changed
      };
      setFeaturesChanged({ ...featuresChanged, ...changed });
      setFeatureToggles(newFeatures);
    }
  };
  const handleClearCacheClick = () => {
    setFeaturesChanged({});
    setIsClearingCache(true);
    location.reload();
  };
  if (!isClient || !isDebugModeFeatureTogglesEnabled || !isFeatureToggleDebugModeActivated) {
    return null;
  }
  return /* @__PURE__ */ React__namespace.createElement(common.Drawer, { direction: drawerDirection }, /* @__PURE__ */ React__namespace.createElement(FeatureTogglesControlPanelTrigger.FeatureTogglesControlPanelTrigger, null), /* @__PURE__ */ React__namespace.createElement(common.Drawer.Portal, null, /* @__PURE__ */ React__namespace.createElement(common.Drawer.Backdrop, null), /* @__PURE__ */ React__namespace.createElement(common.Drawer.Overlay, null, /* @__PURE__ */ React__namespace.createElement(common.Drawer.Header, { LeftSlot: !isRightDirection && Title, RightSlot: /* @__PURE__ */ React__namespace.createElement(common.Drawer.CloseButton, null) }), !isRightDirection && /* @__PURE__ */ React__namespace.createElement(common.Drawer.Divider, null), /* @__PURE__ */ React__namespace.createElement(common.Drawer.Content, null, isRightDirection && Title, /* @__PURE__ */ React__namespace.createElement("div", { className: "feature-toggles-control-panel" }, /* @__PURE__ */ React__namespace.createElement(irisUi.Text, { variant: "text-caption", className: "feature-toggles-control-panel__explanation" }, "Turn feature toggles on or off. Changes are saved ", /* @__PURE__ */ React__namespace.createElement("strong", null, "only"), " in your browser. To reset to Vault's default features, click on clear cache button below."), /* @__PURE__ */ React__namespace.createElement(
    irisUi.ButtonOutline,
    {
      component: "button",
      icon: "Refresh",
      isLoading: isClearingCache,
      onPress: handleClearCacheClick,
      size: "small",
      className: "feature-toggles-control-panel__local-cache-button"
    },
    "Clear local cache"
  ), /* @__PURE__ */ React__namespace.createElement(
    irisUi.CheckboxGroup,
    {
      value: enabledFeatures,
      onChange: handleCheckboxChange,
      className: "feature-toggles-control-panel__checkbox-group",
      label: "Select feature toggles",
      showLabel: false
    },
    Object.keys(featureToggles).map((feature) => /* @__PURE__ */ React__namespace.createElement("div", { key: feature }, /* @__PURE__ */ React__namespace.createElement(irisUi.BadgeCheckbox, { value: feature }, feature)))
  ))))));
};
exports.FeatureTogglesControlPanel = FeatureTogglesControlPanel;
//# sourceMappingURL=FeatureTogglesControlPanel.js.map
